/**
 * Adds rows a grid list does not have yet; a row whose id is already there keeps its current
 * values, and a batch that repeats an id adds only the first one. COMPLETE merges a year of
 * closed shipments into the open lists, so for a batch the ids on hand are collected once
 * instead of scanning the whole list for every new row, which grew with existing x new rows.
 * A single row (a shipment just created or pushed live) keeps the plain one-pass check.
 */
export const addUniqueById = (list, rows) => {
    if (!Array.isArray(rows)) {
        if (!list.some((row) => row.id === rows.id)) list.push(rows);
        return;
    }
    if (rows.length === 0) return;
    const ids = new Set(list.map((row) => row.id));
    rows.forEach((row) => {
        if (ids.has(row.id)) return;
        ids.add(row.id);
        list.push(row);
    });
};
